import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TabbedShowLayout, useRecordContext } from "react-admin";
import ElectionHeader from "../../components/ElectionHeader";
import { EditContestData } from "./EditContestData";
import { CircularProgress } from "@mui/material";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import { configuredLanguage, useInheritedLanguage } from "@/hooks/usePresentationName";
export var ContestTabs = function () {
    var _a;
    var aliasRenderer = useAliasRenderer();
    var record = useRecordContext();
    var inheritedLanguage = useInheritedLanguage(record);
    if (!record) {
        return _jsx(CircularProgress, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(ElectionHeader, { title: aliasRenderer(record, (_a = configuredLanguage(record)) !== null && _a !== void 0 ? _a : inheritedLanguage), subtitle: "contestScreen.common.subtitle" }), _jsx(TabbedShowLayout, { children: _jsx(TabbedShowLayout.Tab, { label: "Data", children: _jsx(EditContestData, {}) }) })] }));
};
